export class ShapePosition {
    public width:number;
    public height:number;
    public top:number;
    public left:number;

}


// WEBPACK FOOTER //
// ./src/app/creator/canvas/shapePosition.ts